import { Box, Button, HStack, Input, Text } from '@chakra-ui/react';
import { AxiosError } from 'axios';
import useCart from 'hooks/useCart';
import useCatchError from 'hooks/useCatchError';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CartRepository } from 'respository/cart.repository';
import { useSWRConfig } from 'swr';

function CartCoupon() {
  // use i18n
  const { t } = useTranslation(['cart']);

  // use catch error hook
  const catchError = useCatchError();

  // use react-hook-form
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<{
    code: string;
  }>();

  const { cartMutate } = useCart();

  // use state to store coupon error message
  const [couponErrorMessage, setCouponErrorMessage] = useState<string>('');

  // use state to store coupon submit loading
  const [couponSubmitLoading, setCouponSubmitLoading] =
    useState<boolean>(false);

  const handleApplyCoupon = async (values: { code: string }) => {
    try {
      // reset coupon error message
      setCouponErrorMessage('');

      // set coupon submit loading
      setCouponSubmitLoading(true);

      const data = await CartRepository.applyCoupon(values.code);

      console.log('data', data);

      cartMutate();
    } catch (error) {
      console.log('error', error);
      catchError(error);

      if (error instanceof AxiosError) {
        if (error.response && error.response.data) {
          if (error.response.data.error === 'COUPON_NOT_FOUND') {
            setCouponErrorMessage(
              t('ไม่พบคูปองหรือคูปองหมดอายุแล้ว', { ns: 'cart' })
            );
          }
        }
      }
    } finally {
      // set coupon submit loading
      setCouponSubmitLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(handleApplyCoupon)}>
      <HStack alignItems="flex-start">
        <Box flex={1}>
          <Input
            type="text"
            placeholder={t('cart.coupon.placeholder', {
              // TH: ใส่รหัสคูปอง
              // EN: Coupon code
            })}
            {...register('code', {
              required: t('form.message.required', {
                ns: 'common',
              }),
            })}
            _placeholder={{ color: 'gray.200' }}
            bg="white"
            border="0"
          />
          {couponErrorMessage && (
            <Text color="red.600" fontSize="sm" mt={2}>
              {couponErrorMessage}
            </Text>
          )}
        </Box>
        <Box flex="0 0 auto">
          <Button bg="gray.800" type="submit" isLoading={couponSubmitLoading}>
            {t('cart.coupon.action.apply', {
              // TH: ใช้
              // EN: Apply
            })}
          </Button>
        </Box>
      </HStack>
    </form>
  );
}

export default CartCoupon;
